import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Breadcrumb from '@/components/feature/Breadcrumb';
import CategoryPage from './components/CategoryPage';

export default function Category() {
  return (
    <>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <CategoryPage />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}